import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ICatalog } from '../../shared/types/main-catalog';

import { fetchSearch, fetchSearchPage } from './search.actions';
import { SearchState } from './search.interface';

const initialState: SearchState = {
  value: '',
  showMenu: false,
  limit: 16,
  items: null,
  itemsPage: null,
  handleSearch: false,
  visibleHistory: false,
  handleEnter: false,
  historyItems: [],
};

export const searchSlice = createSlice({
  name: 'searchSlice',
  initialState,
  reducers: {
    setSearchValue(state, action: PayloadAction<string>) {
      state.value = action.payload;
    },
    setSearchClear(state) {
      state.value = '';
    },
    setShowMenu(state, action: PayloadAction<boolean>) {
      state.showMenu = action.payload;
    },
    setLimit(state, action: PayloadAction<number>) {
      state.limit = action.payload;
    },
    setHandleSearch(state, action: PayloadAction<boolean>) {
      state.handleSearch = action.payload;
    },
    setVisibleHistory(state, action: PayloadAction<boolean>) {
      state.visibleHistory = action.payload;
    },
    setHandleEnter(state, action: PayloadAction<boolean>) {
      state.handleEnter = action.payload;
    },
    setHistoryItems(state, action: PayloadAction<string[]>) {
      state.historyItems = action.payload;
    },
  },
  extraReducers: {
    [fetchSearch.fulfilled.type]: (state, action: PayloadAction<ICatalog>) => {
      state.items = action.payload;
    },
    [fetchSearchPage.fulfilled.type]: (
      state,
      action: PayloadAction<ICatalog>
    ) => {
      state.itemsPage = action.payload;
    },
  },
});
export const searchActions = searchSlice.actions;
export const { reducer } = searchSlice;
